function screenshotFade ($section) {

  var $animation_elements = $(".screenshot-fade");

  $animation_elements.each(function(i) {
    var delay = 330;
    var animationLength = 500;

    if (i <= 4) {
      delay += 170 * i;
    }

    if (i === 5) {
      delay += 1170;
    }

    if (i === 6) {
      delay += 1670;
      animationLength = 670;
    }

    $(this).delay(delay).animate({opacity: 1}, {
      step: function() {
        if(!$(this).hasClass("screenshot-line")) {
          $(this).css({
            '-webkit-transform': 'scale(1)',
            'transition': 'transform ' + animationLength + 'ms cubic-bezier(0.455, 0.03, 0.515, 0.955)'
          });
        } else {
          $(this).css({ '-webkit-transform': 'scale(1)' });
        }
      }
    }, animationLength);
  });
}
